import strings from "./LoadingSpinner.strings";
import { useStrings } from "features/i18n/useStrings";
import { GuxPageLoadingSpinner } from "genesys-spark-components-react";

export function LoadingSpinner() {
    const t = useStrings(strings);
    return <GuxPageLoadingSpinner screenreader-text={t.loading} />;
}
